var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import classNames from "classnames";
// styles
import "./progressBar.scss";
// use the optional prop interface to define the default props
const defaultProps = {
    "data-testid": "tecma-progressBar",
};
const ProgressBar = (_a) => {
    var { value, valueToShow, className } = _a, rest = __rest(_a, ["value", "valueToShow", "className"]);
    const classList = classNames("tecma-progressBar", className);
    return (_jsxs("div", Object.assign({ className: classList }, rest, { children: [_jsx("div", { className: "progressBar", style: { width: `${value}%` } }), valueToShow && _jsx("span", { className: "progressBar-value", children: valueToShow })] })));
};
ProgressBar.defaultProps = defaultProps;
/**
 * A horizontal bar indicating the current completion status of a long-running task, usually updated continuously as the task progresses, instead of in discrete steps.
 */
export default React.memo(ProgressBar);
